import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { Project } from 'src/app/model/project/project';
import { SubProject } from 'src/app/model/project/sub-project';

@Component({
  selector: 'adjustment-invoicing-container',
  templateUrl: './adjustment-invoicing-container.component.html',
  styleUrls: ['./adjustment-invoicing-container.component.scss']
})
export class AdjustmentInvoicingContainerComponent {
  @Input()
  public project: Project;
  @Input()
  public inputSubProject: SubProject;
  @Input()
  public invoiceSent: Subject<any>;
  @Input()
  public collapsed: boolean = true;
  @Input()
  public embeddedInQuotation: boolean = false;
  @Output()
  public outputInvoice = new EventEmitter<any>();
}
